import male1 from './male1.png'
import male2 from './male2.png'
import male3 from './male3.png'
import male4 from './male4.png'
import female1 from './female1.png'
import female2 from './female2.png'
import female3 from './female3.png'
import female4 from './female4.png'
const images = [
  male1, 
  male1, 
  male2, 
  male2, 
  male3, 
  male3, 
  male4, 
  male4, 
  female1, 
  female1, 
  female2, 
  female2, 
  female3, 
  female3, 
  female4, 
  female4
]
export default images